import fr from '~/locales/fr-FR'

export default defineNuxtPlugin({
  name: 'i18n-messages',
  dependsOn: ['i18n:plugin'],
  setup (nuxtApp) {
    const i18n = nuxtApp.$i18n as any
    i18n.mergeLocaleMessage('fr', fr)
  }
})
